import { Button, Group } from "@mantine/core";

import { useFeedbackDraftStore } from "../../store";
import classes from "../../styles.module.css";
import { getTemplateFields } from "../../types";

export function isDescriptionEmpty(description: string, category: string, templateResponses?: Record<string, string>) {
    const fields = getTemplateFields(category);
    if (fields) {
        return !templateResponses || Object.values(templateResponses).every((v) => !v.trim());
    }
    return !description.trim();
}

interface FeedbackActionProps {
    isLoading: boolean;
    onSubmit: VoidFunction;
    onClear: VoidFunction;
}
export function FeedbackActions({ isLoading, onSubmit, onClear }: FeedbackActionProps) {
    // Select derived booleans so typing only re-renders the actions when a button's state actually flips
    const shouldHideClearButton = useFeedbackDraftStore(
        ({ draft }) => !draft.description && !draft.category && !draft.templateResponses,
    );
    const isDraftIncomplete = useFeedbackDraftStore(
        ({ draft }) =>
            !draft.category || isDescriptionEmpty(draft.description, draft.category, draft.templateResponses),
    );
    return (
        <Group justify="flex-end" gap="sm">
            {!shouldHideClearButton && (
                <Button
                    className={classes.clearButton}
                    variant="subtle"
                    color="white"
                    size="compact-lg"
                    td="underline"
                    onClick={onClear}
                    disabled={isLoading}
                    data-testid="clear-feedback-button"
                >
                    Clear
                </Button>
            )}
            <Button
                variant="filled"
                color="primary.5"
                size="compact-lg"
                onClick={onSubmit}
                disabled={isDraftIncomplete || isLoading}
                data-testid="submit-feedback-button"
                loading={isLoading}
            >
                Submit
            </Button>
        </Group>
    );
}
